export default {
  namespaced: true,
  actions: {
    async notifyAboutCurrentState ({ dispatch }) {
      return window._interopToCEF.notifyAboutCurrentState();
    },
    async getStationIdentity ({ dispatch }) {
      return window._interopToCEF.getStationIdentity();
    },
    startGame ({ dispatch }, { id, type, restartIfRunning }) {
      return window._interopToCEF.startGame({ id, type, restartIfRunning });
    },
    setDashboard ({ dispatch }, { visible, locked }) {
      window._interopToCEF.setDashboard({ visible, locked });
    },
    forceSetIdle ({ dispatch }, { idle }) {
      window._interopToCEF.forceSetIdle({ idle });
    },
    setAudio ({ dispatch }, { volume }) {
      window._interopToCEF.setAudio({ volume });
    },
    stationChanged ({ dispatch }, station) {
      // HACK temporary fix
      if (!station.experience) return;
      const patchedStation = { ...station };
      if (!patchedStation.idleMode || patchedStation.safetyMode) {
        patchedStation.idleMode = 'disabled';
      }
      window._interopToCEF.stationChanged(patchedStation);
    },
    gamesChanged ({ dispatch }, games) {
      window._interopToCEF.gamesChanged(games);
    },
    panelsChanged ({ dispatch }, panels) {
      window._interopToCEF.panelsChanged(panels);
    },
    timerChanged ({ dispatch }, timerInfo) {
      window._interopToCEF.timerChanged(timerInfo);
    },
    quitCurrentApp ({ dispatch }) {
      window._interopToCEF.quitCurrentApp();
    },
    bookingChanged ({ dispatch }, { id }) {
      window._interopToCEF.bookingChanged({ id: id || null });
    },
    getCachedFilePath ({ dispatch }, { url }) {
      return window._interopToCEF.getCachedFilePath({ url });
    },
    async cancelLaunch ({ dispatch }) {
      try {
        return await window._interopToCEF.cancelLaunch();
      } catch (e) {
        dispatch('endLoading', 'launchingGame', { root: true }); // legacy end loading for <4.1.5
        throw e;
      }
    },
  },
};
